<template>
  <component
    :is="tag"
    class="button"
    :class="[
      `button--size-${size}`,
      `button--color-${color}`,
      `button--variant-${variant}`,
      {
        'button--full': full,
        'button--loading': loading,
        'button--disabled': disabled
      }
    ]"
    :disabled="disabled"
  >
    <Icon v-if="icon && iconPosition === 'left'" :name="icon" class="button__icon button__icon--left" />
    <span class="button__content">
      <slot />
    </span>
    <Icon v-if="icon && iconPosition === 'right'" :name="icon" class="button__icon button__icon--right" />
  </component>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      tag?: "a" | "button" | "NuxtLinkLocale"
      full?: boolean
      icon?: string
      iconPosition?: "left" | "right"
      size?: "xs" | "sm" | "base" | "lg" | "xl"
      color?: "primary" | "secondary" | "black"
      variant?: "solid" | "outline"
      disabled?: boolean
      loading?: boolean
    }>(),
    {
      tag: "button",
      full: false,
      iconPosition: "left",
      size: "base",
      color: "primary",
      variant: "solid",
      disabled: false,
      loading: false
    }
  )
</script>

<style lang="scss" scoped>
  .button {
    width: fit-content;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: var(--button-height, 52px);
    border: 1px solid var(--button-border);
    color: var(--button-color) !important;
    font-size: var(--button-font-size, 12px);
    padding: var(--button-padding, 0 16px);
    text-transform: uppercase;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.5px;
    outline: none;
    user-select: none;
    cursor: pointer;
    flex: none;
    gap: 8px;

    &__icon {
      font-size: 0.9em;
    }

    &--size {
      &-base {
        --button-height: 52px;

        --button-font-size: 12px;
        --button-padding: 0 36px;
      }
    }
    &--color {
      &-primary {
        --button-color: #ffffff;
        --button-border: #282828;
        --button-background: #282828;
      }
      &-secondary {
        --button-color: #282828;
        --button-border: #c4c4c4;
        --button-background: #c4c4c4;
      }
    }
    &--variant {
      &-solid {
        background: var(--button-background);
      }
      &-outline {
        --button-color: #282828;
        background: transparent;
      }
    }

    &--full {
      width: 100%;
      display: flex;
    }
    &--loading {
      pointer-events: none;
    }
    &--disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
</style>
